import React from 'react';
import propTypes from 'prop-types';
export const StarIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="st0"
        d="M510.549,196.024c-3.812-11.726-14.5-19.868-26.82-20.42l-147.935-6.686l-52.09-138.642
		C279.37,18.739,268.329,11.089,256,11.089c-12.329,0-23.37,7.65-27.704,19.187l-52.089,138.642l-147.935,6.686
		c-12.321,0.552-23.008,8.694-26.821,20.42c-3.812,11.726,0.052,24.598,9.689,32.283l115.756,92.368L87.542,463.453
		c-3.27,11.889,1.155,24.554,11.136,31.808c9.985,7.246,23.404,7.548,33.704,0.758L256,414.473l123.617,81.547
		c10.3,6.789,23.719,6.487,33.704-0.758c9.982-7.245,14.405-19.92,11.131-31.808l-39.347-142.779l115.756-92.368
		C510.498,220.621,514.362,207.749,510.549,196.024z"
      />
    </svg>
  );
};
StarIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
StarIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
